<template>
  <div>
    <!-- Form fields for Question -->
    <div class="row u-no-padding">
      <h6 class="font-light col-12">Question Details</h6>
    </div>
    <div class="row u-no-padding">
      <div class="col-5" v-bind:class="{ 'input-error': error.topic }">
        <label for="topic">Topic</label>
        <multiselect
          v-model="question.topic"
          :options="topics"
          label="name"
          track-by="id"
          v-bind:disabled="canChange"
          placeholder="Select..."
        ></multiselect>
        <div class="u-vertical-center error" v-if="error.topic">
          &emsp;{{ error.topic }}
        </div>
      </div>
      <div class="col-3" v-bind:class="{ 'input-error': error.marks }">
        <label>Marks Available</label>
        <div class="input-control">
          <input
            name="marks"
            type="number"
            placeholder="Marks"
            v-model="question.marks"
            v-bind:disabled="canChange"
          />
        </div>
        <div
          class="u-vertical-center error"
          v-if="error.marks"
          v-bind:disabled="question.read_only"
        >
          {{ error.marks }}
        </div>
      </div>
      <div class="col-2">
        <label>Is Mandatory</label>
        <div class="input-control">
          <input
            name="is_mandatory"
            :value="question.is_mandatory"
            type="checkbox"
            v-model="question.is_mandatory"
            v-bind:disabled="canChange"
          />
        </div>
      </div>
      <div class="col-2" v-bind:class="{ 'input-error': error.is_active }">
        <label>Is Active</label>
        <div class="input-control">
          <input
            name="is_active"
            value="true"
            type="checkbox"
            v-model="question.is_active"
            v-bind:disabled="canChange"
          />
        </div>
        <div class="u-vertical-center error" v-if="error.is_active">
          {{ error.is_active }}
        </div>
      </div>
    </div>
    <div class="row u-no-padding">
      <div class="col-12">
        <label>Syllabus Item</label>
        <input
          type="text"
          v-model="question.syllabus"
          v-bind:disabled="canChange"
        />
      </div>
    </div>
    <div class="row u-no-padding">
      <div class="col-12">
        <label>Answer Reference</label>
        <input
          type="text"
          v-model="question.reference"
          v-bind:disabled="canChange"
        />
      </div>
    </div>
    <div class="row u-no-padding" v-bind:class="{ 'input-error': error.text }">
      <h6 class="font-light col-3">Question</h6>
      <div
        class="offset-5 col-4 u-vertical-center error u-text-right"
        v-if="error.text"
      >
        {{ error.text }}
      </div>
      <div class="col-12">
        <textarea
          v-model="question.text"
          v-bind:disabled="canChange"
        ></textarea>
      </div>
    </div>
    <div class="row u-no-padding">
      <h6 class="col-12 font-light">
        Choices
        <a href="#question-modal">
          <i class="fa fa-wrapper fa-info-circle" style="color: blue;"> </i>
        </a>
      </h6>
    </div>
    <div
      id="question-modal"
      class="modal modal-animated--dropdown modal-normal"
    >
      <a href="#target" class="modal-overlay close-btn" aria-label="Close"></a>
      <div class="modal-content" role="document">
        <div class="modal-header">
          <a href="#components" class="u-pull-right" aria-label="Close">
            <span class="icon">
              <i class="fa fa-wrapper fa-times"></i>
            </span>
          </a>
          <div class="modal-title">Question Choices Explained</div>
          <div class="modal-subtitle">
            How the Question Type is Determined
          </div>
        </div>
        <div class="divider u-no-margin"></div>
        <div class="modal-body">
          <p>
            The number of choices you enter will determine whether the question
            is a <i>short answer</i> or <i>multiple choice</i> question:
          </p>
          <dl>
            <dt>Enter Only <span class="success">Correct Answer</span></dt>
            <dd>
              If you only enter the
              <span class="success">correct answer</span> and
              <span class="error">no </span
              ><strong>other choices are entered</strong>, then the question
              will be a <i>short answer</i> question.
            </dd>
            <dt>Enter <span class="error">More Than One (>1) Choice</span></dt>
            <dd>
              If you enter <strong>more than one choice</strong>, then the
              question will be a <i>multiple choice</i> question.
            </dd>
          </dl>
        </div>
      </div>
    </div>
    <div
      class="row u-no-padding"
      v-bind:class="{ 'input-error': error.answer }"
    >
      <div class="col-12">
        <label class="col-3 correct-answer">Correct Answer</label>
        <div class="offset-5 error u-text-right" v-if="error.answer">
          &emsp;{{ error.answer }}
        </div>
        <div>
          <input
            type="text"
            v-model="question.answer"
            v-bind:disabled="canChange"
          />
        </div>
      </div>
    </div>
    <div class="row u-no-padding">
      <div
        class="col-12"
        v-for="(num, idx) in [1, 2, 3, 4, 5]"
        :key="`choice-${idx}`"
      >
        <label>Choice {{ num }}</label>
        <input
          type="text"
          v-model="question['choice_' + num]"
          v-bind:disabled="canChange"
        />
      </div>
    </div>
  </div>
</template>
<style>
.input-control {
  margin-top: 0;
}
.correct-answer {
  color: #0dd157;
  font-weight: bold;
}
</style>
<script>
import { mapGetters } from "vuex";
import Multiselect from "vue-multiselect";

export default {
  name: "question-form",
  components: {
    Multiselect
  },
  props: ["question", "error", "canChange"],
  computed: {
    ...mapGetters("questions", ["topics"])
  },
  mounted() {
    if (!this.topics || this.topics.length == 0) {
      this.$store.dispatch("questions/getTopics");
    }
  }
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
